// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1Wr0C","title":"card_title__3wES-","inActive":"card_inActive__TqHs3"};